import { LitElement, html, css } from 'lit';
import { accessibility, grid, details } from '../../utilities/styles';
import { processZoneData } from '../../utilities/zoneUtilities';
import { yellowTick, expandIcon, collapseIcon, arrowBack } from '../../utilities/icons';
import { AllInLocationListingsConsumer } from '../Utilities/AllInLocationLIstingsConsumer';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInZone extends AllInLocationListingsConsumer(LitElement) {
    static properties = {
        ...super.properties,
        name: { type: String },
        zone: { type: String },
        restUrl: { type: String },
        nonce: { type: String },
        _selectedImage: { type: String, state: true },
        _provisionData: { type: Array, state: true },
    };
    constructor() {
        super();
    }
    async connectedCallback() {
        super.connectedCallback();
        this._selectedImage = 'photo1';
        await this._setZoneData();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }
    /* updated(changedProperties){

    } */
    render() {
        if (!this.currentZone) {
            return html `<allin-loader></allin-loader>`;
        }
        let mobileaside;
        let main = '';
        let loop = [];
        let images = [this.currentZone[this._selectedImage], this.currentZone.photo1, this.currentZone.photo2, this.currentZone.photo3];
        images = images.filter((i) => !!i);
        if (images.length > 0) {
            if (images.length == 2) {
                images = [images[0]];
            }
            images.forEach((image, i) => {
                if (i == 0) {
                    loop.push(html `\n                            <div class="item grid--featured">\n                                <img src="${image.publicUrl}" alt="${image.altText}" />\n                            </div>`);
                }
                else {
                    loop.push(html `\n                            <div class="card item grid--image ${image.name == this._selectedImage ? 'selected' : ''}">\n                                <img src="${image.publicUrl}" alt="${image.altText}"/>\n                                <a href="#" class="card_target" @click=${(e) => { e.preventDefault(); this._selectedImage = 'photo' + i; }}>\n                                    <span class="screen-reader-text">View photo ${i}></span>\n                                </a>\n                            </div>`);
                }
            });
        }
        let description = this.currentZone.description;
        let name = this.currentZone.name;
        let zoneType = this.currentZone.zoneType;
        let type = '';
        if (zoneType) {
            type = html `<div class="bg_white border inner-padding zone_type"><h3>${zoneType}</h3></div>`;
        }
        let text = html `\n                <h2>About ${name}</h2><allin-markdown-editor value="${description}" readonly></allin-markdown-editor>`;
        let provisionsLoop = this._allZoneProvisions?.map((_provision) => {
            let markup = [];
            _provision.provisions.forEach((provision) => {
                let thisProvisionData = this._provisionData.find((item) => {
                    return item.standardId == provision.id;
                });
                if (thisProvisionData) {
                    let description = thisProvisionData?.description;
                    let image = thisProvisionData?.image;
                    let altText = thisProvisionData?.alt;
                    markup.push(html `\n                                <div class="provision item grid grid--icon">\n                                    <div class="icon">${yellowTick}</div>\n                                    <div class="text">\n                                        <p><strong>${provision.name}</strong></p>\n                                        <allin-markdown-editor value="${description}" readonly></allin-markdown-editor>\n                                        ${image ? html `<img width="200" height="130" src="${image}" alt="${altText}" />` : ''}\n                                    </div>\n                                </div>\n                                    \n                            `);
                }
            });
            if (markup.length == 0) {
                return '';
            }
            let icon = _provision.title.toLowerCase().replace(/\s+/g, '_').replace(/[^\w]/g, '') + '.svg';
            return html `\n                        <details class="provisions">\n                        <summary><img src="/wp-content/themes/ace/assets/icons/purple/${icon}" alt="Icon representing ${_provision.title}" @error=${(e) => { if (e.target.src !== "/wp-content/themes/ace/assets/icons/purple/default_provision.svg") {
                e.target.src = '/wp-content/themes/ace/assets/icons/purple/default_provision.svg';
            } }} />${_provision.title}</summary>\n                        <div class="panel">\n                            ${markup}\n                        </div>\n                    </details>\n                    `;
        });
        let hasProvisions = provisionsLoop?.filter((item) => item != '');
        let provisionsPre = '';
        if (!hasProvisions || hasProvisions.length == 0) {
            provisionsPre = html `<p class="small">No provisions have been added to this zone yet</p>`;
        }
        else {
            provisionsPre = html `<div class="collapsers">\n\t\t\t\t\t<button class="expand_all" @click=${this._expandCollapseAll}>${expandIcon}Expand all</button>\n\t\t\t\t\t<button class="collapse_all" @click=${this._expandCollapseAll}>${collapseIcon}Collapse all</button>\n\t\t\t\t</div>`;
        }
        mobileaside = html `<div class="mobile-aside">${this._currentLocationSidebar}</div>`;
        main = html `\n                <div class="location">\n                    <div class="image-grid">${loop}</div>\n                    <div class="location_text">\n                        ${type}\n                        ${text}\n                    </div>\n                    <aside class="sidebar mobile-sidebar">${mobileaside}</aside>\n                    <div class="bg">\n                        <h2>Relevant access information</h2>\n                        ${provisionsPre}\n                        ${provisionsLoop} \n                    </div>\n                    <a @click=${this._handleGoBack} href="#" class="button"><span aria-hidden=true>${arrowBack}</span>Return to ${this.location.name}</a>\n                </div>\n            `;
        return html `${main}`;
    }
    async _setZoneData() {
        if (!this._allZoneProvisions?.length) {
            await this._fetchAllProvisions();
        }
        ({ provisionData: this._provisionData } = await processZoneData(this.currentZone));
    }
    async _fetchAllProvisions() {
        let url = `${this.restUrl}?action=get_all_zone_provisions`;
        try {
            const response = await fetch(url, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Public': 'public',
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            const data = await response.json();
            this._allZoneProvisions = data.zoneProvisions;
            this._loading = false;
            this._updateContext({ 'allZoneProvisions': this._allZoneProvisions });
        }
        catch (error) {
            console.error('Error:', error);
        }
    }
    _handleGoBack(e) {
        e.preventDefault();
        this._updateContext({ 'currentZoneID': null, 'currentZone': null });
    }
    _expandCollapseAll(e) {
        e.preventDefault();
        let targets = this.shadowRoot.querySelectorAll('.provisions');
        if (e.currentTarget.classList.contains('expand_all')) {
            targets.forEach(target => {
                target.setAttribute('open', '');
            });
        }
        else {
            targets.forEach(target => {
                target.removeAttribute('open');
            });
        }
    }
    static styles = [
        accessibility,
        grid,
        details,
        css `
        :host{
            width:100%;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
        }
        .bg_white{
            background-color:#fff;
        }
        .border{
            border:1px solid var(--allin-border-color,#707070);
        }
        .inner-padding{
            padding:1rem;
        }

        .grid{
            gap:1.5rem;
        }
        h2{
            font-size:1.5rem;
            color:var(--allin-highlight-color,#472961);
        }
        .image-grid{
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            container-type: inline-size;
        }

        .grid--featured{
            flex-basis: 100%;
            background-color: transparent;
            max-height: 450px;
            line-height: 0;
        }
        .grid--image {
            flex-shrink: 1;
            flex-grow: 0;
            flex-basis: 0;
            height: 150px;
        }

        .grid--featured img{
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: top;
            line-height: 0;
        }
        .grid--image img{
            width: auto;
            height: 100%;
            object-fit: cover;
            /* object-position: top; */
            max-width: calc(33cqw - 0.67rem);
        }

        .grid--image.selected{
            outline: 4px solid var(--allin-secondary-color,#FFCE58);
        }
        .provisions{
            background-color:#fff;
            border-radius:0.4rem;
            border:1px solid #707070;
            padding:0;
            margin-bottom:1rem;
        }
        .provisions summary{
            padding:1rem 1rem;
            margin:0;
            font-size:1.25rem;
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            cursor:pointer;
            display: flex;
            align-items: center;
            gap: 1.5rem;
        }
        .provisions summary::after{
            right:1rem;
            top:1.2rem;
        }
        .provisions .panel{
            padding:0.5rem 1rem;
        }
        input:read-only:not([type=submit]) {
            background-color: #fff;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .collapsers{
            margin-right:auto;
            margin-bottom:1rem;
            display: flex;
            gap: 1rem;
            width: fit-content;
        }
        .collapsers button{
            background-color: transparent;
            color: var(--allin-highlight-color,#472961);
            border: 0;
            cursor: pointer;
            font-weight: 700;
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }

        .grid--icon {
            grid-template-columns: 1.6rem 1fr;
            gap: 1.5rem;
            margin-bottom: 1rem;
            width: 100%;
        }

        /** Mobile sidebard to show up only below 999px */
        aside.sidebar.mobile-sidebar{
            display: none;
            padding: 2.5rem 0;
            max-width: 300px;
        }
        .mobile-sidebar .grid--icon {
            margin-bottom: unset;
            border-bottom: 1px solid var(--allin-border-color, #707070);
            padding: 1rem 0;
        }
        .mobile-sidebar .grid--icon svg{
            width: 1.6rem;
            height: auto;
        }
        .mobile-sidebar .grid--icon svg path{
            fill: var(--allin-highlight-color, #472961);
        }
        .mobile-sidebar p{
            margin: 0;
        }
        .mobile-sidebar .grid--icon p strong{
            color: var(--allin-regular-text-color, #1a1a1a);
        }
        .mobile-sidebar a{
            color: var(--allin-text-color, #472961);
            text-decoration: underline;
            font-weight: 600;
            white-space: normal;
            overflow-wrap: break-word;
            word-break: break-word;
            display: inline;
        }
        .mobile-sidebar .return a{
            font-size: 1.25rem;
            font-weight: 700;
        }
        .mobile-sidebar .grid--icon+.item.text {
            padding-top: 1rem;
        }
        .mobile-sidebar .item.text {
            padding: 0 0 1rem;
        }
        .mobile-sidebar .return{
            padding: 0;
            margin-bottom: 2rem;
        }

        p{
            margin-top:0;
        }

        .provisions summary::after {
            right: 1rem;
            top: 1.2rem;
        }
        .zone_type{
            margin-top:1rem;
        }
        .zone_type h3{
            margin:0;
            font-size:1rem;
            color:var(--allin-highlight-color,#472961);
        }

        @media screen and (max-width: 999px) {
            aside.sidebar.mobile-sidebar{
                display: block;
            }
        }

        .provision .text img{
            width:200px;
            height:130px;
        }

        .button{
            display:block;
            margin-top:2rem;
            color:var(--allin-highlight-color,#472961);
            text-decoration:none;
            font-weight:600;
            display:flex;
            align-items:center;
            gap:0.5rem;
            svg{
                transition: transform var(--transition) ease;
            }
            &:hover{
                text-decoration:underline;
                svg{
                    transform:translateX(-5px);
                }
            }

        }
        `
    ];
}
